interface Props {
  value: string;
  label: string;
}

export default function KpiCard({ value, label }: Props) {
  return (
    <div className="kpi-card">
      <div className="kpi-value">{value}</div>
      <div className="kpi-label">{label}</div>
    </div>
  );
}
